// Highlight palette for the app side: the colours come from
// highlight-palette.cjs, which tailwind.config.js also consumes as the
// `highlight-*` tokens, and this module layers the API-enum mapping on top.
//
// The API persists the ENUM, not the hex, so retuning a colour re-renders
// existing highlights with no migration.
import palette from './highlight-palette.cjs';

export const HIGHLIGHT_COLORS = [
  { value: palette.yellow, name: 'Yellow', enumValue: 'YELLOW' },
  { value: palette.green, name: 'Green', enumValue: 'GREEN' },
  { value: palette.blue, name: 'Blue', enumValue: 'BLUE' },
  { value: palette.pink, name: 'Pink', enumValue: 'PINK' },
];

// Colour a highlight falls back to, and the swatch the drawer opens on.
export const DEFAULT_HIGHLIGHT_COLOR = HIGHLIGHT_COLORS[0].value;
export const DEFAULT_HIGHLIGHT_ENUM = HIGHLIGHT_COLORS[0].enumValue;

// Palette values shipped before the pastel retune. They still arrive from the
// read-cache in localStorage (which stores hex, not the enum), so they have to
// stay decodable: without them hexToEnum falls through to its default and a
// cached green/blue/pink highlight is silently re-encoded as YELLOW the next
// time the reader resizes or recolours it. Decode-only — nothing writes these.
const LEGACY_HEX_TO_COLOR_ENUM = {
  '#FFEB3B': 'YELLOW',
  '#4CAF50': 'GREEN',
  '#2196F3': 'BLUE',
  '#EC407A': 'PINK',
};

export const HEX_TO_COLOR_ENUM = {
  ...LEGACY_HEX_TO_COLOR_ENUM,
  ...Object.fromEntries(HIGHLIGHT_COLORS.map(c => [c.value, c.enumValue])),
};
export const COLOR_ENUM_TO_HEX = Object.fromEntries(
  HIGHLIGHT_COLORS.map(c => [c.enumValue, c.value]),
);
